import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.143 1.257c0-.426.307-.771.686-.771h8.96c1.475 0 2.697 1.249 2.697 2.828v12.343c0 1.58-1.222 2.829-2.697 2.829h-8.96c-.38 0-.686-.346-.686-.772 0-.426.307-.771.686-.771h8.96c.746 0 1.325-.593 1.325-1.286V3.314c0-.693-.58-1.285-1.325-1.285h-8.96c-.38 0-.686-.346-.686-.772zM.666 9.078l.074-.086 4.115-4.115A.771.771 0 016.02 5.882l-.075.086L3.15 8.766h7.702c.233 0 .425.285.458.657l.005.114c0 .387-.171.708-.394.763l-.069.009H3.148l2.797 2.797a.772.772 0 01.075 1.004l-.075.087a.772.772 0 01-1.004.075l-.086-.075L.74 10.083a.772.772 0 01-.074-1.005z",
		fillRule: "evenodd"
	})
});
export default SvgArrowLeft;
